import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './utils/i18n/i18n'
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './utils/msal/authConfig';
import { setZXingModuleOverrides } from "barcode-detector";

// Override para librería qr-scan
setZXingModuleOverrides({
  locateFile: (path, prefix) => {
    if (path.endsWith(".wasm")) {
      return `${process.env.PUBLIC_URL}/zxing/zxing_reader.wasm`;
    }
    return prefix + path;
  },
});

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MsalProvider instance={msalInstance}>
        <App />
    </MsalProvider>
);

// Registrar Service Worker para funcionalidad offline
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {

                // Escuchar actualizaciones del service worker
                registration.addEventListener('updatefound', () => {
                  const newWorker = registration.installing;
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                              window.location.reload();
                            }
                        });
                    }
                });
            })
            .catch((error) => {
                console.error('❌ Error registrando Service Worker:', error);
            });
    });
}
